var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product_variable_size"},[_c('h4',{staticClass:"tetx_m mb5"},[_vm._v(_vm._s(_vm.typeText(_vm.type))+":")]),_vm._l((_vm.options),function(option,index){return _c('span',{key:index,class:[{
            disabled: option.disabled, 
            selected: _vm.current==option.id,
            product_variable_size_item: option.type == 2,
            product_variable_color_item: option.type == 1
        }, option.text],on:{"click":function($event){return _vm.changeCurrent(option.id)}}},[_vm._v(_vm._s(option.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }